<template>
    <div class="story-maker-sticker story-maker-sticker-slider" :class="{edit: isSelected}" @click="finish">
        <img class="img-change-color" :src="require('@/assets/img/instagram/ehf.png')" @click="stickerInstance.nextColor">
        <!-- <p class="text-finish" @click="finish">Terminé</p> -->
        <div 
            class="sticker sticker-slider"
            :class="[`color-${stickerInstance.data.color.slice(1).toUpperCase()}`]"
            :style="{ 
                backgroundColor: stickerInstance.data.color,
            }"
        >
            <div class="slider-header" v-if="isSelected || stickerInstance.data.question">
                <textarea @input="resize" :value="stickerInstance.data.question" cols="20" rows="2" wrap="hard" maxlength="100" :placeholder="$t('dash.post-creator.story.survey-question')" :readonly="!isSelected" ref="textareaSlider"></textarea>
            </div>
            <div class="slider">
                <span class="emoji">{{stickerInstance.data.emoji}}</span>
                <div class="bar"></div>
            </div>
          
        </div>

        <div class="list-emoji">
            <carousel :perPage="1" :adjustableHeight="true" :centerMode="true" @pageChange="()=>{}" >
                <Slide v-for="(emojis,index) in [['😍','😂','😀','🔥','😡','😱','😢','🙌'],['❤️','🎉','👍','💩','💯','🙏','😮','add']]" :key="index">
                   
                    <template v-for="emo in emojis">
                        <div v-if="emo == 'add'" class="add" @click="displayEmojiPicker = true"><i class="fa-regular fa-plus"></i></div>
                        <div v-else class="emoji" @click="stickerInstance.data.emoji = emo">{{ emo }}</div>
                    </template>
                  
                </Slide>
            </carousel>
        </div>

        <Picker
            :data="emojiIndex"
            v-show="isSelected && displayEmojiPicker"
            @select="addEmoji"
            ref="emojiPicker"
            :style="pickerStyle"
            :i18n="{
                search: $t('dash.post-creator.story.emoji-search'),
                notfound: $t('dash.post-creator.story.emoji-not-found'),
                categories: {
                    search: $t('dash.post-creator.story.emoji-cat-search'),
                    recent: $t('dash.post-creator.story.emoji-cat-recent'),
                    smileys: $t('dash.post-creator.story.emoji-cat-smileys'),
                    people: $t('dash.post-creator.story.emoji-cat-people'),
                    nature: $t('dash.post-creator.story.emoji-cat-nature'),
                    foods: $t('dash.post-creator.story.emoji-cat-foods'),
                    activity: $t('dash.post-creator.story.emoji-cat-activity'),
                    places: $t('dash.post-creator.story.emoji-cat-places'),
                    objects: $t('dash.post-creator.story.emoji-cat-objects'),
                    symbols: $t('dash.post-creator.story.emoji-cat-symbols'),
                    flags: $t('dash.post-creator.story.emoji-cat-flags'),
                    custom: $t('dash.post-creator.story.emoji-cat-custom'),
                },
            }"
            :color="'#b64985'"
    />
     
    </div>
</template>

<script>
    import { Picker, EmojiIndex  } from 'emoji-mart-vue-fast'
    import emojiData from '@/constants/emoji-mart-vue-fast/all.json'
    import { Carousel, Slide } from 'vue-carousel';
    import { EventBus } from '@/event-bus';

    const colorsHeader = ["#FFFFFF","#0C0F14", "#FF0164", "#FD01D2", "#8A2EFF", "#FF6300", "#00D93D", "#009BFF", "#00CBFE"]
    
    export default {
        components: {
            Picker,
            Carousel,
            Slide
        },

        props: {
            id: Number | String,
            stickerInstance: {
                type: Object,
                required: true
            },
            isSelected: Boolean,
        },

        mounted () {
            this.$nextTick(()=> {
                if(this.isSelected) this.focusAtEnd()
                this.resize({target: this.$refs[`textareaSlider`]})
            })
        },

        data() {
            return {
                emojiIndex: new EmojiIndex(emojiData, {
                    recentLength:18,
                    recent: ['tada','sparkles','rocket','confetti_ball','fire', 'heart','speech_balloon','heart_eyes','raised_hands','two_hearts','bulb','brain', 'loudspeaker', 'star2', 'wrench','hammer_and_wrench','calendar','spiral_calendar_pad'],
                }),
                displayEmojiPicker : false,
            }
        },

        methods: {
            unselected() {
            },

            finish(event) {
                if (this.isSelected && event.target.classList.contains('story-maker-sticker') || event.target.classList.contains('text-finish')) {
                    this.$emit('unselect')
                }
            },

            addEmoji (emoji, idx) {
                this.stickerInstance.data.emoji = emoji.native
                this.displayEmojiPicker = false
            },

            focusAtEnd() {

                try {
                    const element = this.$refs[`textareaSlider`]

                    const range = document.createRange();
                    const selection = window.getSelection();

                    range.selectNodeContents(element);
                    range.collapse(false);

                    selection.removeAllRanges();
                    selection.addRange(range);

                    // Donnez le focus à l'élément
                    element.focus();
                } catch (error) {
                    
                }

            },

            resize(e) {
                const maxLine = 3
                let element = e.target;
                const lineHeight =  parseFloat(getComputedStyle(element).lineHeight);
          
                element.style.height = `${lineHeight}px`;
                const scrollHeight = element.scrollHeight;
                console.log("resize lineHeight", lineHeight)
                console.log("resize scrollHeight", scrollHeight)
                if (scrollHeight >= lineHeight * (maxLine+1)) {
                    element.style.height = `${lineHeight * maxLine}px`;
                    element.value = this.stickerInstance.data.question
                }else{
                    // this.$set(this.models ,'question' , element.value)
                    this.stickerInstance.data.question = element.value
                    element.style.height = Math.min(scrollHeight,lineHeight * maxLine) + "px";
                }
            },
        },

        watch: {
            isSelected: {
                isSelected(newValue) {
                    if (newValue) { 
                        this.$nextTick(()=> {
                            if(this.isSelected) this.focusAtEnd()
                        })
                    }
                },
                immediate: true
            },
        
            
        }
    }
</script>

<style lang="scss" scoped>

</style>